const DEFAULT_OPTIONS = {
  lng: "ru",
  style: "decimal"
};
function formatDecimal(value, options) {
  const resolvedOptions = {
    ...DEFAULT_OPTIONS,
    ...options
  };
  const { lng, ...intlOptions } = resolvedOptions;
  return new Intl.NumberFormat(lng, intlOptions).format(value);
}
export {
  formatDecimal
};
